/**
 * Remove Etsy OAuth tokens and selected shop from worker KV for this scope.
 * Does not revoke tokens at Etsy — only clears local integration state.
 */
export async function disconnectEtsy(brandId?: string): Promise<void> {
  const qs = brandId ? `?brandId=${encodeURIComponent(brandId)}` : ''
  const res = await fetch(`/api/etsy/disconnect${qs}`, { method: 'POST' })
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`)
  }
  const data = await res.json()
  if (!data?.ok) {
    throw new Error(data?.message || data?.error || 'disconnect_failed')
  }
}
